import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import { isValidIBAN } from "../../../utils/utils";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import InfoBankTemplate from "../../../components/info-perso-template/InfoBankTemplate";
import GeneralDataProtectionBloc from "../../common/GeneralDataProtectionBloc";
import { getAllIndexByString } from "../../../utils/utils";


type InfoBankFormData = {
  iban: string;
  bankingHolder: string;
  attachRibId: string | null;
  ribHolderConfirm: boolean;
}

export default function REInfoBankBloc() {

  const navigate = useNavigate();
  const {
    state: { updatedProposition, ribDocument },
    dispatch,
  } = useAppState();


  const validationSchema = Yup.object().shape({
    bankingHolder: Yup.string()
      .required(ERROR_MESSAGES.requiredMsg) 
      .min(2, ERROR_MESSAGES.invalidMsg)
      .max(50, ERROR_MESSAGES.invalidMsg)
      .matches(/^[a-zA-Z '-]+$/i, ERROR_MESSAGES.invalidName)
      .test('invalidCombination', ERROR_MESSAGES.invalidMsg, (val)=> {
        let invalidCase = val?.includes('--') === true ;
        let isDashInTheMiddle;
        if(val){
          const indexList = getAllIndexByString(val, "-");
          isDashInTheMiddle = indexList.indexOf(0) !== -1 || indexList.indexOf(val.length-1) !== -1;
        }
        return !invalidCase && !isDashInTheMiddle;
      }),
    iban: Yup.string().required(ERROR_MESSAGES.requiredMsg)
      .test("is-france-IBAN", ERROR_MESSAGES.franceIBANMsg, (value) => {
        const FRvalid = value?.slice(0,2) === 'FR'
        return FRvalid;
      })
      .test("is-IBAN-valid", ERROR_MESSAGES.invalidIBANMsg, (value) => {
        const valid = isValidIBAN(value as string, );
        return valid;
      }),
    ribHolderConfirm: Yup.bool().oneOf([true],ERROR_MESSAGES.requiredMsg)
  });


  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<InfoBankFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      bankingHolder: updatedProposition?.bankingHolder ? updatedProposition?.bankingHolder : '',
      iban: updatedProposition?.iban ? updatedProposition.iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim(): "",
      attachRibId: ribDocument?.id ? ribDocument?.id : null,
      ribHolderConfirm: updatedProposition?.ribHolderConfirm ? updatedProposition?.ribHolderConfirm: false
    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = async (data: InfoBankFormData) => {
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.iban = data.iban;
      tempUpdatedPropo.bankingHolder = data.bankingHolder;
      tempUpdatedPropo.ribHolderConfirm = data.ribHolderConfirm;
    }
    const nextUrl = APP_RETIREMENT_URLS.infoAttestationROPage
   
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo});
    navigate({
        pathname: nextUrl
    });         
  }

  const onPreviousAction = async () => {
    const url = updatedProposition?.hasOldMutual ? APP_RETIREMENT_URLS.infoOldContractPage : APP_RETIREMENT_URLS.infoContactPage;
   
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url
    });         
  }


  return (
    <form style={{width: '100%'}}>
        <div className='form-row page-content'>
          <InfoBankTemplate register={register} setValue={setValue} errors={errors} reset={reset} />
           
        </div>
        <StickButtonsBloc 
            showPreviousButton={true} 
            disabledPreviousButton={false} 
            nextAction={handleSubmit(onNextAction)} 
            showNextButton={true} 
            previousAction={onPreviousAction}/>
        <GeneralDataProtectionBloc/>
    </form>
  )
}